app.directive('simpleCaptcha', function () {
    return {
        restrict: 'E',
        scope: { valid: '=' },
        template: '<input maxlength="1" ng-model="a.value" tabindex = "{{tabIndex}}" ng-change="checkValue()" ng-show="a.input" style="width:2em; text-align: center;" class="numbersOnly"><span ng-hide="a.input">{{a.value}}</span>&nbsp;{{operation}}&nbsp;<input maxlength="1"  ng-change="checkValue()" ng-model="b.value" tabindex = "{{tabIndex}}" ng-show="b.input" style="width:2em; text-align: center;" class="numbersOnly"><span ng-hide="b.input">{{b.value}}</span>&nbsp;=&nbsp;{{result}}',
        link: function ($scope, element, attrs) {

            var a, b, result;

            $scope.tabIndex = attrs.tabindex === undefined ? "" : attrs.tabindex;

            $scope.reloadCaptcha = function () {
                var show = Math.random() > 0.5;

                var value = function (max) {
                    return Math.floor(max * Math.random());
                };

                var int = function (str) {
                    return parseInt(str, 10);
                };

                $scope.a = {
                    value: show ? undefined : 1 + value(4),
                    input: show
                };
                $scope.b = {
                    value: !show ? undefined : 1 + value(4),
                    input: !show
                };
                $scope.operation = '+';

                $scope.result = 5 + value(5);

                a = $scope.a;
                b = $scope.b;
                result = $scope.result;
            }

            $scope.reloadCaptcha();

            $scope.$on('reloadCaptcha', function (event, data) {
                $scope.reloadCaptcha()
            });

            var checkValidity = function () {

                if (a.value && b.value) {
                    var calc = parseInt(a.value) + parseInt(b.value);
                    $scope.valid = calc == result;
                } else {
                    $scope.valid = false;
                }
                //$scope.$apply(); // needed to solve 2 cycle delay problem; Commented because this throws exception in the response of LogDetails.aspx
            };


            $scope.$watch('a.value', function () {

                checkValidity();
            });

            $scope.$watch('b.value', function () {

                checkValidity();
            });

            $scope.checkValue = function () {
                var ans = parseInt($scope.a.value) + parseInt($scope.b.value);
                if (ans == $scope.result) {
                    $('simple-captcha').removeClass('border-all-red');
                } else {
                    $('simple-captcha').addClass('border-all-red');
                };
            };
        }
    };
});

